// src/analytics/utils/visitorClientUtils.js

export function getCurrentPage() {
  return `${window.location.pathname}${window.location.search}`;
}

export function getUtmData(search = window.location.search) {
  const params = new URLSearchParams(search);

  return {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_term: params.get("utm_term"),
    utm_content: params.get("utm_content"),
  };
}

export function detectDeviceType() {
  const userAgent = navigator.userAgent || "";

  if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
    return "tablet";
  }

  if (
    /mobile|iphone|ipod|android.*mobile|blackberry|opera mini|iemobile/i.test(
      userAgent,
    )
  ) {
    return "mobile";
  }

  return "desktop";
}

export function detectBrowser() {
  const userAgent = navigator.userAgent || "";

  if (userAgent.includes("Edg/")) {
    return {
      browser_name: "Edge",
      browser_version:
        userAgent.match(/Edg\/([\d.]+)/)?.[1] || null,
    };
  }

  if (userAgent.includes("Firefox/")) {
    return {
      browser_name: "Firefox",
      browser_version:
        userAgent.match(/Firefox\/([\d.]+)/)?.[1] || null,
    };
  }

  if (
    userAgent.includes("Chrome/") &&
    !userAgent.includes("Edg/")
  ) {
    return {
      browser_name: "Chrome",
      browser_version:
        userAgent.match(/Chrome\/([\d.]+)/)?.[1] || null,
    };
  }

  if (
    userAgent.includes("Safari/") &&
    !userAgent.includes("Chrome/")
  ) {
    return {
      browser_name: "Safari",
      browser_version:
        userAgent.match(/Version\/([\d.]+)/)?.[1] || null,
    };
  }

  return {
    browser_name: "Inconnu",
    browser_version: null,
  };
}

export function detectOperatingSystem() {
  const userAgent = navigator.userAgent || "";

  if (/Windows/i.test(userAgent)) return "Windows";
  if (/Android/i.test(userAgent)) return "Android";
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
  if (/Mac OS X|Macintosh/i.test(userAgent)) return "macOS";
  if (/Linux/i.test(userAgent)) return "Linux";

  return "Inconnu";
}

export function buildVisitorSessionPayload({
  sessionToken = null,
  page,
  title,
  search,
}) {
  const browser = detectBrowser();

  return {
    session_token: sessionToken,

    page,
    page_title: title || document.title,
    referrer: document.referrer || null,

    ...getUtmData(search),

    device_type: detectDeviceType(),
    browser_name: browser.browser_name,
    browser_version: browser.browser_version,
    os_name: detectOperatingSystem(),

    language: navigator.language || null,

    timezone:
      Intl.DateTimeFormat().resolvedOptions().timeZone ||
      null,

    screen_width: window.screen?.width || null,
    screen_height: window.screen?.height || null,
  };
}